<template>
  <div class="cmp-catalog-tracks-tracks_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img @click="onAddLabelsListClick" class="dt-icon v5 s1" src="static/buttons/add.svg" alt />
        </div>
      </div>
      <div class="search">
        <InputField  :value="basicFilter.searchString" :placeholder="$t('search')" :config="{
          borderStyle: 'bottom',
          maxWidth: '200px',
          minWidth: '200px',
          width: '200px'
        }" @keyup="onSearchInputKeyup"></InputField>
        <Dropdown
          :options="statusesTV"
          style="margin-top: -1px; margin-left: 20px; min-width: 150px"
          :placeholder="$t('status')"
          deselect
          borderbottom
          :selected="
           label_status_ids
          " 
          multiple
          allnone
          v-on:selectedChange="(e) => onStatusChange('label_status_ids', e)"
        >
        </Dropdown>
        
        <Dropdown
          :options="typeTV"
          style="margin-top: -1px; margin-left: 20px; min-width: 150px"
          :placeholder="$t(`type_string`)"
          :title="$t(`type_string`)"
          deselect
          borderbottom
          :selected="
           typeTV.find((e) => e.value == type)
          "
          v-on:selectedChange="(e) => onDropdownChange('type', e)"
        >
        </Dropdown>
        <Dropdown
          :options="royalty_statusTV"
          style="margin-top: -1px; margin-left: 20px; min-width: 150px"
          :placeholder="$t('royalty_status')"
          deselect
          borderbottom
          :selected="
            royalty_statusTV.find((e) => e.value == royalty_status)
          "
          v-on:selectedChange="(e) => onDropdownChange('royalty_status', e)"
        >
        </Dropdown>
        <DTIconButton
          :classNames="'search--advanced'"
          :text="'Advanced Search'"
          :style="{
            minWidth: '148px',
            maxWidth: '148px',
            cursor:'pointer'
          }"
          icon="add-blue"
          @click="onAdvancedSearchClick"
        />
      </div>
      <div class="search-config--container">
        <div class="search-config">
          <SearchConBadge
            v-for="sconKey of filteredAdvancedSearchConfigKeys"
            :key="sconKey"
            v-bind="searchConfigKey(sconKey)"
            @delete="onSearchConDelete"
          />
        </div>
      </div>
      <DTCheckbox  :id="'no_autofetch'" :label="$t('no_autofetch_contracts')" :checked="no_autofetch"
        @click="onLabelsNoAutofetchClicked" :h="'auto'" />
     
     
    </div>

    <div   class="dt-page--body">
      <NTable id="catalog-labels-label_list" class="h1" 
      :config="tableConfig" 
      :headers="distributionHeaders" 
      :items="list"
      :loadingFlag="loadingFlag"  
        @scrollnext="onListScroll">
        <template v-slot:item="{ item, tdcon }">
          <tr :class="{
            selected: selectedRow(item)
          }" @click="onLabelsClicked(item)" :title="$t('click_to_see_tracks_list')">
            <td v-bind="tdcon('labels')">
                   <div class="ut-flex">
                <DtStatus
                  :statusTVList="statusTV"
                  :item="getItemForStatus(item)"
                  @updateStatus="onLabelStatusChange"
                />
                <span>{{ item["label_name"] }}</span>
              </div>
            </td>
            <td v-bind="tdcon('type')">
              <span class="txtov" :title="item['label_type']">{{
                item["label_type"]
              }}</span>
            </td>
            <td v-bind="tdcon('label_contact')">
              <span class="txtov" :title="item['contact']">{{
                item["contact"]
              }}</span>
            </td>
            <td v-bind="tdcon('label_ras_auto_fetch')">
              <span class="txtov" :title="item['auto_fetch_accounts']">{{
                item["auto_fetch_accounts"]
              }}</span>
            </td>
            <td v-bind="tdcon('label_release_count')">
              <span class="txtov" :title="item['release_count']">{{
                item["release_count"]
              }}</span>
            </td>
            <td v-bind="tdcon('royalty_status')">
              <span class="txtov" :title="item['status_display']">{{
                item["status_display"]
              }}</span>
            </td>
            <td v-bind="tdcon('emails')">
              <div class="dt-icon-container">
                <img @click.stop="e => onLabelMailClick(item)" v-if="item['emails']"
                  src="static/icons/email/email-grey.svg" class="dt-icon v5 s2" :alt="$t('mail_label')"
                  :title="$t('mail_label')" />
              </div>
            </td>
            <td v-bind="tdcon('options')">
              <img v-if="item['show_delete']>0" src="static/icons/delete.svg" @click.stop="e => onLabelDelete(item)"
                class="dt-icon v5 s2 ut-center" alt />
            </td>
           
          </tr>
        </template>
      </NTable>
    </div>
    <DtPageStatusFloat :statusTV="statusTV" />
    <Sidewindow :navConfig="defaultConfig" :value="labelsDetailsFlag" @closed="onCloseLabelsDetails">
      <LabelsSidewindow :statusTV="statusesTV||[]"/>
    </Sidewindow>

    <ModalContainer :modalKey="'addLabel'" :width="'small'">
      <AddLabel @cancelled="onDialogCancelled" @added="onAdded" />
    </ModalContainer>
    <ModalContainer :modalKey="'deactiveLabel'" :width="'350'">
      <LabelStatusDeactivateModal @cancelled="onDialogCancelled" />
    </ModalContainer>
    <ModalContainer :modalKey="'advancedSearch'" width="small">
      <AdvancedSearch
        :advancedSearchData="advancedSearchData"
        :initSearchFilter="searchFilter"
        @search="onAdvancedSearch"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
  </div>
</template>

<script>
import InputField from "@plugins/text-field/input-field";
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "@/plugins/datatable/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import * as ActionTypes from "../../store/types";
import { CatalogStoreNamespace as storeNS } from "../../store";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { labelsCatalogActions } from "../../store/labels/actions";
import { labelsCatalogGetters } from "../../store/labels/getters";
import { Subject } from "rxjs";
import { createModalMixin } from "../../../../dt-plugins/modal/modal.mixin";
import { subscribeSubject } from "../../../../utility";
import { LoadedEnd } from "../../../../dt-plugins/advanced-search/load.model";
import {
  getLabelsDetailsSelectable,
  labelsListLDTRoutes
} from "../../router/routes";
import {
  childOfOrEqualDetails,
  handleFromRoute
} from "../../../../utility/route";
import {
  createLDTHost,
  defaultConfig
} from "../../../../dt-plugins/sidewindow";
import DtPageStatusFloat from "@dtplugins/dtpage-status/dtpage-status-float";
import { createTV, createTVI } from "../../../../models/text-value.model";
import AddLabel from "./add-label";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import LabelsSidewindow from "./labels-sidewindow";
import { LabelsService } from "../../services/labels.service";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import DtStatus from "../../../../dt-plugins/dt-status-dropdown/dt-status.vue";
import LabelStatusDeactivateModal from "./label-status-deactivate-modal.vue";
import { createAdvancedSearchHost } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import AdvancedSearch from './advanced-search'
import { labelListAdvancedSearchConfig } from './advanced-search.vue';
const listLength = 100;

const LDTConfig = {
  entityName: "label",
  ldtRoutes: labelsListLDTRoutes,
  detailsSelectableFunction: getLabelsDetailsSelectable,
  primaryKey: "label_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.LabelDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.LabelDetails.FETCH.SINGLE
};

export default {
  components: {
    InputField,
    DTIconButton,
    NTable,
    ModalContainer,
    DTCheckbox,
    DtPageStatusFloat,
    DtStatus,
    AddLabel,
    LabelsSidewindow,
    LabelStatusDeactivateModal,
    AdvancedSearch
  },
  data: function () {
    return {
      term: "",
      searchSubject: new Subject(),
      labelType: 'standard',
      startFrom: 0,
      loadedStart: 0,
      loadedEnd: false,
      scrollSubject: new Subject(),
      selectedClickedLabel: null,
      no_autofetch: null,
      royalty_status:null,
      type:null,
      label_status_ids:[],
      royalty_status:null,
      labelData:null,
      defaultConfig: defaultConfig,
      getLabelsDetailsSelectable: getLabelsDetailsSelectable
    };
  },
  mounted: async function () {
    this.getLabels();
   // this.fetchListReset();
    // subscribeSubject(this, this.searchSubject, term => {
    //   this.fetchListReset();
    // });

    // subscribeSubject(this, this.scrollSubject, scrollTop => {
    //   if (this.label_list_start_from == this.startFrom) {
    //     this.startFrom += listLength;
    //     this.fetchListNext();
    //   }
    // });
  },
  mixins: [
    createLDTHost(LDTConfig), 
    createModalMixin("addLabel"),
    createFetchListMixin(ActionTypes.LabelList.FETCH.ALL, 30, {
        advancedSearchable: false,
        searchable: true,
        scrollable: true,
    }),
    createModalMixin("deactiveLabel"),
    createAdvancedSearchHost( labelListAdvancedSearchConfig ),
    createModalMixin("advancedSearch"), 
  ],
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) { }
    }
  },
  computed: {
    ...mapGetterObject(storeNS, labelsCatalogGetters),
    advancedSearchData : function(){
      

      // const maxYear = new Date(this.advancedSearchResponse?.dates.max_date).getFullYear();
      // const minYear=new Date(this.advancedSearchResponse?.dates.min_date).getFullYear();
      // console.log("maxYear,minYear",maxYear,minYear)
      // const hArray = flatten(range(+minYear, +maxYear+1).map(e => {
      //   return [`${e} H1`,`${e} H2`];
      // }));

      return {
        // licenceAccountStatusTV:createTV(this.advancedSearchResponse?.licence_account_statuses,"label_status_name","label_status_id")||[],
        // licenceTypesTV:createTV(this.advancedSearchResponse?.licence_statuses,"label_status_name","label_status_id"),
        // royaltyAccountTV:createTV(this.advancedSearchResponse?.royalty_accounts,"royalty_account_name","royalty_account_id"),
        // territoryTV:createTV(this.advancedSearchResponse?.territories,"territory_name","territory_id"),
        //lastStmtTV: createTV(hArray),
      };
    },

    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40
      });
    },
    statusTV: function () {
      return createTVI(
        this.labelData?.statuses,
        "label_status_name",
        "label_status_colour",
        "label_status_id"
      ) || [];
    },
    statusesTV: function () {
      return createTV(this.labelData?.statuses, "label_status_name", "label_status_id");
    },
    royalty_statusTV: function () {
      return (
        this.labelData?.royalty_status?.map((e) => {
          return {
            text: e,
            value:e,
            
          };
        }) || []
      );
    },
    typeTV: function () {
      return (
        this.labelData?.label_types?.map((e) => {
          return {
            text: e,
            value:e,
          };
        }) || []
      );
    },
    list: function () {
      return this.labelList?.labels || [];
      // return this.labelList && this.labelList.all_labels || [];
    },
    
    distributionHeaders: function () {
      return [
        createTableHeader("labels", { fw: 700 }),
        createTableHeader("type", {
          
        }),
        createTableHeader("label_contact", {
          text: "Contact",
          f: 1.5
        }),
        createTableHeader("label_ras_auto_fetch", { f: 1.5 }),
        createTableHeader("label_release_count", {
          f: 0.6,
          mw: 150
        }),
        createTableHeader("royalty_status", {
          text: "Royalty Status",
          f: 1.5
        }),
        createTableHeader("emails", {
          text: false,
          mw: 40
        }),
        createTableHeader("options", { text: false, mw: 40 })
      ];
    },
    headers: function () {
      return [
        createTableHeader("labels", { fw: 700 }),
        createTableHeader("label_contact", {
          text: "Label Contacts",
          f: 1.5
        }),
        createTableHeader("label_ras_auto_fetch", { f: 1.5 }),
        createTableHeader("label_release_count", {
          f: 0.5,
          mw: 106
        }),
        createTableHeader("related_emails", {
          text: false,
          mw: 40
        }),
        createTableHeader("options", { text: false, mw: 40 })
      ];
    },
    // filter: function () {
    //   return {
    //     term: this.term,
    //     status:this.status,
    //     royalty_status:this.royalty_status,
    //     type:this.type && this.type.length > 0
    //       ? this.type.map((e) => e.value).join(",")
    //       : undefined,
    //     no_autofetch:
    //       this.no_autofetch === true
    //         ? 'no autofetch'
    //         : this.no_autofetch === false
    //           ? ''
    //           : undefined
    //   };
    // },
    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      };
    },
    labelsDetailsFlag: function () {
      return childOfOrEqualDetails(labelsListLDTRoutes, this.$route);
    }
  },
  methods: {
    ...mapActionObject(storeNS, labelsCatalogActions),
    fetchAdvancedSearchData :async function(){
     // const advancedSearchData = await licenceService.licenceAdvancedSearchModalData();
      //console.log("advancedSearchData",advancedSearchData)
      this.advancedSearchResponse = { } //advancedSearchData.data;
    },
  async getLabels(){
   let res=await LabelsService.getLabels();
   this.labelData=res.data
  },
  getItemForStatus: function (item) {
    //console.log(this.statusTV,":::::::::::::::::::::::::::::::::::")
      return {
        itemID: item.label_id,
        colorPropertyName: "label_status_id",
        colorPropertyValue: item.label_status_id,
        colorName: "label_status_colour",
        colorValue: this.statusTV?.find((x) => x.id === item.label_status_id)?.value,
      };
    },
  defaultBasicFilter() {
      return {
        searchString: undefined,
        label_status_ids: undefined,
        royalty_status: undefined,
        type:undefined,
        no_autofetch:undefined,
      };
    },

    onDropdownChange: function (name, value) {
      this.basicFilter[name] = value.value;
      this[name] = value.value;
      this.fetchListReset();
    },
    onStatusChange: function (name, value) { 
      console.log('value',value)
      this.label_status_ids = value;
      this.basicFilter[name]=this.label_status_ids && this.label_status_ids.length > 0
           ? this.label_status_ids.map((e) => e.value).join(",")
           : undefined;
      this.fetchListReset();
    },
    onLabelStatusChange: function (payload) {
      //const item = this.selectedReleaseDetails;
      //
      const statusArray =  this.labelData?.statuses;

      const colorPropertyValue = payload.colorPropertyValue;

      const inactive_flag = statusArray.find(x=>x.label_status_id == colorPropertyValue ).inactive_flag;



      if(inactive_flag && (inactive_flag==1 || inactive_flag=='1')){
        this.$router.push({
          ...this.$route,
          query: {
            modal: "deactive_label",
            primary_key:payload.itemID,
            name:this.list.find(x=>x.label_id==payload.itemID).label_name,
            status_id:colorPropertyValue,
            mode:'deactivate'

          }
        });
      }else{
        this.$router.push({
          ...this.$route,
          query: {
            modal: "deactive_label",
            primary_key:payload.itemID,
            name:this.list.find(x=>x.label_id==payload.itemID).label_name,
            status_id:colorPropertyValue,
            mode:'activate'

          }
        });
      } 

      this[ActionTypes.LabelList.UPDATE.SINGLE](payload);




      console.log(payload,'payload')
    },

    // Marks
    onAddLabelsListClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_label"
        }
      });
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined
        }
      });
    },
    onTrackScroll: function (value) {
      console.log("Label Scroll");
      this.scrollSubject.next(value);
    },
    selectedRow: function (label) {
      return (
        this.selectedClickedLabel &&
        this.selectedClickedLabel["label_id"] == label["label_id"]
      );
    },
    refresh: function () {
      this.fetchListNext();
    },

    onAdded: async function (item) {

      console.log("::", item)

      const { label_id } = item;

      this.fetchList();
      this.onDialogCancelled();
      this.$router.push({
        name: labelsListLDTRoutes.names.tab,
        params: {
          label_id: label_id,
          tab: "overview"
        }
      });




    },

    onLabelDelete: async function (item) {
      const confirmationResult = await confirmDelete(
        "label name",
        item.label_name
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.LabelList.DELETE.SINGLE](item);
      }
    },

    onLabelsNoAutofetchClicked: function (event) {
      this.basicFilter.no_autofetch = event.target.checked?1:0;
      this.no_autofetch =  event.target.checked;
      this.fetchListReset();
    },
    onFilterButtonClicked: function (type) {
      this.labelType = type;
      this.no_autofetch=null;
      this.type=null;
      this.status=null;
      this.term=null;

      this.fetchListReset();
    },

    onLabelMailClick: function (item) {
      // console.log('Label Mail ', item.related_emails);
      location.href = `mailto: ${item.emails}`;
    },

    // Start Sidewindow
    onLabelsClicked: function (label) {
      this.selectedClickedLabel = label;
      this.$router.push({
        name: labelsListLDTRoutes.names.tab,
        params: {
          label_id: label.label_id,
          tab: "overview"
        }
      });
    },
    onCloseLabelsDetails: function () {
      this.selectedClickedLabel = null;
      handleFromRoute(this, () => {
        this.$router.push({
          name: labelsListLDTRoutes.names.list
        });
      });
    },

    onAdvancedSearchClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "advanced_search",
        },
      });
    },
    // End Sidewindow
  }
};
</script>

<style lang="scss" scoped>
.cmp-catalog-tracks-tracks_list {
  .dt-page--body {
    --offset: 120px;
  }

  .catalog-labels-label_list {
    td {
      &.label_release_count {
        text-align: center;
      }
    }
  }
}
</style>
